document.addEventListener("DOMContentLoaded", () => {
  isSubscriptionProperty();
});

function isSubscriptionProperty() {
  const product_forms = document.querySelectorAll(".product-form-tabs form");
  product_forms.forEach((form) => {
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = "properties[_is_subscription]";
    input.id = "_is_subscription";
    input.className = "is-subscription";
  
    const radios = form.querySelectorAll('input[name="selling_plan_option"]');
    const defaultSelectedRadio = form.querySelector('input[name="selling_plan_option"]:checked');
    if (defaultSelectedRadio) {
      input.value = defaultSelectedRadio.value;
    }
  
    form.addEventListener("change", (e) => {
      const selectedRadio = e.target.closest('input[name="selling_plan_option"]');
      if (selectedRadio) {
        input.value = selectedRadio.value;
      }
    });
  
    // Place the input inside the form
    form.appendChild(input);
  });
}